"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntl = require("react-intl");
var _jsxFileName = "/codebuild/output/src3938275692/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/ui/Price/lib/Price.js",
  _templateObject,
  _this = void 0;
function cov_1u6xy1impv() {
  var path = "/codebuild/output/src3938275692/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/ui/Price/lib/Price.js";
  var hash = "2db19933a749ecf5db5d0e01002f6afb87c8c270";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3938275692/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/ui/Price/lib/Price.js",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 16
        },
        end: {
          line: 8,
          column: 4
        }
      },
      "1": {
        start: {
          line: 14,
          column: 14
        },
        end: {
          line: 37,
          column: 1
        }
      },
      "2": {
        start: {
          line: 15,
          column: 23
        },
        end: {
          line: 15,
          column: 76
        }
      },
      "3": {
        start: {
          line: 15,
          column: 38
        },
        end: {
          line: 15,
          column: 76
        }
      },
      "4": {
        start: {
          line: 18,
          column: 6
        },
        end: {
          line: 25,
          column: 8
        }
      },
      "5": {
        start: {
          line: 28,
          column: 2
        },
        end: {
          line: 36,
          column: 4
        }
      },
      "6": {
        start: {
          line: 39,
          column: 0
        },
        end: {
          line: 52,
          column: 2
        }
      },
      "7": {
        start: {
          line: 54,
          column: 0
        },
        end: {
          line: 60,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 14,
            column: 14
          },
          end: {
            line: 14,
            column: 15
          }
        },
        loc: {
          start: {
            line: 14,
            column: 86
          },
          end: {
            line: 37,
            column: 1
          }
        },
        line: 14
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 15,
            column: 23
          },
          end: {
            line: 15,
            column: 24
          }
        },
        loc: {
          start: {
            line: 15,
            column: 38
          },
          end: {
            line: 15,
            column: 76
          }
        },
        line: 15
      },
      "2": {
        name: "getPricePart",
        decl: {
          start: {
            line: 17,
            column: 11
          },
          end: {
            line: 17,
            column: 23
          }
        },
        loc: {
          start: {
            line: 17,
            column: 61
          },
          end: {
            line: 26,
            column: 3
          }
        },
        line: 17
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 15,
            column: 38
          },
          end: {
            line: 15,
            column: 76
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 15,
            column: 50
          },
          end: {
            line: 15,
            column: 69
          }
        }, {
          start: {
            line: 15,
            column: 72
          },
          end: {
            line: 15,
            column: 76
          }
        }],
        line: 15
      },
      "1": {
        loc: {
          start: {
            line: 18,
            column: 14
          },
          end: {
            line: 24,
            column: 15
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 18,
            column: 14
          },
          end: {
            line: 18,
            column: 33
          }
        }, {
          start: {
            line: 19,
            column: 8
          },
          end: {
            line: 24,
            column: 15
          }
        }],
        line: 18
      },
      "2": {
        loc: {
          start: {
            line: 22,
            column: 80
          },
          end: {
            line: 22,
            column: 98
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 22,
            column: 80
          },
          end: {
            line: 22,
            column: 92
          }
        }, {
          start: {
            line: 22,
            column: 96
          },
          end: {
            line: 22,
            column: 98
          }
        }],
        line: 22
      },
      "3": {
        loc: {
          start: {
            line: 32,
            column: 7
          },
          end: {
            line: 33,
            column: 34
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 32,
            column: 7
          },
          end: {
            line: 32,
            column: 25
          }
        }, {
          start: {
            line: 32,
            column: 29
          },
          end: {
            line: 32,
            column: 47
          }
        }, {
          start: {
            line: 33,
            column: 8
          },
          end: {
            line: 33,
            column: 34
          }
        }],
        line: 32
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "2db19933a749ecf5db5d0e01002f6afb87c8c270"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1u6xy1impv = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1u6xy1impv();
var Wrapper = (cov_1u6xy1impv().s[0]++, _styledComponents.default.span.attrs({
  className: 'g-price'
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)([""]))));

/*
 * Component to display a price or a range of price (from or to). If you pass a minAmount or maxAmount, the amount is ignored.
 * The amount values must be the exact value of amount multiplied by 1000 (to ensure having integer and not float)
 */
cov_1u6xy1impv().s[1]++;
var Price = function Price(_ref) {
  var minAmount = _ref.minAmount,
    amount = _ref.amount,
    maxAmount = _ref.maxAmount,
    currencyCode = _ref.currencyCode,
    labelFrom = _ref.labelFrom,
    labelTo = _ref.labelTo;
  cov_1u6xy1impv().f[0]++;
  cov_1u6xy1impv().s[2]++;
  var displaySpace = function displaySpace(displayed) {
    cov_1u6xy1impv().f[1]++;
    cov_1u6xy1impv().s[3]++;
    return displayed ? (cov_1u6xy1impv().b[0][0]++, /*#__PURE__*/_react.default.createElement("span", {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 15,
        columnNumber: 51
      }
    }, "\xA0")) : (cov_1u6xy1impv().b[0][1]++, null);
  };
  function getPricePart(labelPart, amountPart, withEndSpace) {
    cov_1u6xy1impv().f[2]++;
    cov_1u6xy1impv().s[4]++;
    return (cov_1u6xy1impv().b[1][0]++, amountPart !== null) && (cov_1u6xy1impv().b[1][1]++, /*#__PURE__*/_react.default.createElement("span", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 19,
        columnNumber: 9
      }
    }, labelPart, displaySpace(!!labelPart), /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedNumber, {
      value: amountPart / 1000,
      style: "currency",
      currency: (cov_1u6xy1impv().b[2][0]++, currencyCode) || (cov_1u6xy1impv().b[2][1]++, ''),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 22,
        columnNumber: 11
      }
    }), displaySpace(withEndSpace)));
  }
  cov_1u6xy1impv().s[5]++;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 5
    }
  }, getPricePart(labelFrom, minAmount, maxAmount !== null), getPricePart(labelTo, maxAmount), (cov_1u6xy1impv().b[3][0]++, minAmount === null) && (cov_1u6xy1impv().b[3][1]++, maxAmount === null) && (cov_1u6xy1impv().b[3][2]++, getPricePart(null, amount)));
};
cov_1u6xy1impv().s[6]++;
Price.propTypes = {
  /** The amount to display with currency */
  amount: _propTypes.default.number,
  /** The max amount, display the value prefixed with to */
  maxAmount: _propTypes.default.number,
  /** The min amount, display the value prefixed with from */
  minAmount: _propTypes.default.number,
  /** The section object to display */
  currencyCode: _propTypes.default.string.isRequired,
  /** Custom From label */
  labelFrom: _propTypes.default.node,
  /** Custom To label */
  labelTo: _propTypes.default.node
};
cov_1u6xy1impv().s[7]++;
Price.defaultProps = {
  amount: null,
  maxAmount: null,
  minAmount: null,
  labelFrom: /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
    id: "gravity.Price.from",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58,
      columnNumber: 14
    }
  }),
  labelTo: /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
    id: "gravity.Price.to",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 12
    }
  })
};
var _default = exports.default = Price;